import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import useEffectUpdateOnly from '@hooks/useEffectUpdateOnly';
import { StatusCodes } from '@constants/enum/common';
import LoadingIndicator from '@components/common/LoadingIndicator/LoadingIndicator';
import TopNavigation from '@components/settings/TopNavigation';
import CreateRoleButton from '@modules/Roles/components/CreateRoleButton/CreateRoleButton';
import {
  CREATE_ROLE_TEXT,
  ROLES_PAGE_DESCRIPTION,
  ROLES_PAGE_TABS,
  ROLES_PAGE_TITLE,
} from '@modules/Roles/constants/roles';
import CustomRoles from '@modules/Roles/features/CustomRoles/CustomRoles';
import PresetRoles from '@modules/Roles/features/PresetRoles/PresetRoles';
import RoleEditorModal from '@modules/Roles/features/RoleEditorModal/RoleEditorModal';
import useRoles from '@modules/Roles/hooks/useRoles';
import styles from './RolesPage.module.scss';

const RolesPage = () => {
  const [roleEditorModalOpen, setRoleEditorModalOpen] = useState(false);

  const {
    fetchRoles,
    fetchRolesStatus,
    createRole,
    createRoleStatus,
    fetchPermissions,
    rolesPageActiveTab,
    setRolesPageActiveTab,
  } = useRoles();

  const tabItems = [
    {
      key: ROLES_PAGE_TABS.presetRoles.key,
      label: ROLES_PAGE_TABS.presetRoles.label,
      children: <PresetRoles />,
    },
    {
      key: ROLES_PAGE_TABS.customRoles.key,
      label: ROLES_PAGE_TABS.customRoles.label,
      children: <CustomRoles />,
    },
  ];

  useEffect(() => {
    fetchRoles();
    fetchPermissions();
  }, [fetchRoles, fetchPermissions]);

  useEffectUpdateOnly(() => {
    if (createRoleStatus === StatusCodes.SUCCESS) {
      setRoleEditorModalOpen(false);
      setRolesPageActiveTab(ROLES_PAGE_TABS.customRoles.key);
    }
  }, [createRoleStatus]);

  if (fetchRolesStatus === StatusCodes.IN_PROGRESS) return <LoadingIndicator />;

  return (
    <div className={styles.rolesPage}>
      <TopNavigation />
      <div className={styles.contentWrapper}>
        <h4>{ROLES_PAGE_TITLE}</h4>
        <p>{ROLES_PAGE_DESCRIPTION}</p>
        <Tabs
          activeKey={rolesPageActiveTab}
          onChange={setRolesPageActiveTab}
          items={tabItems}
          tabBarExtraContent={<CreateRoleButton onClick={() => setRoleEditorModalOpen(true)} />}
        />
      </div>
      <RoleEditorModal
        title={CREATE_ROLE_TEXT}
        open={roleEditorModalOpen}
        onOk={(payload) => createRole(payload)}
        onCancel={() => setRoleEditorModalOpen(false)}
        okText={CREATE_ROLE_TEXT}
      />
    </div>
  );
};

export default RolesPage;
